const CONFIG = {
  serverUrl: process.env.NODE_ENV === 'production'
    ? 'https://react-coding-solutions-collab-server.onrender.com'
    : 'http://localhost:3020'
};

export default CONFIG;
